import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgWifi = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.274 6.413A12.7 12.7 0 0 1 12 5.5c1.623 0 3.229.31 4.726.913a12.4 12.4 0 0 1 4.001 2.597.75.75 0 1 0 1.046-1.076 13.9 13.9 0 0 0-4.487-2.913A14.2 14.2 0 0 0 12 4c-1.813 0-3.61.347-5.286 1.021a13.9 13.9 0 0 0-4.487 2.913.75.75 0 1 0 1.046 1.076 12.4 12.4 0 0 1 4-2.597m4.733 2.71a8.8 8.8 0 0 0-3.299.639 8.6 8.6 0 0 0-2.787 1.816.75.75 0 0 1-1.048-1.073c.937-.915 2.05-1.64 3.274-2.134a10.31 10.31 0 0 1 7.72 0 10.1 10.1 0 0 1 3.274 2.134.75.75 0 0 1-1.048 1.073 8.6 8.6 0 0 0-2.787-1.816 8.8 8.8 0 0 0-3.299-.64m-1.61 3.87a4.35 4.35 0 0 1 3.292 0c.52.213.99.525 1.382.915a.75.75 0 1 0 1.059-1.062 5.7 5.7 0 0 0-1.872-1.241 5.85 5.85 0 0 0-4.43 0 5.7 5.7 0 0 0-1.873 1.241.75.75 0 1 0 1.06 1.062c.391-.39.86-.702 1.381-.915m.489 4.447c0-.565.478-1.06 1.114-1.06s1.114.495 1.114 1.06S12.636 18.5 12 18.5s-1.114-.495-1.114-1.06M12 14.88c-1.423 0-2.614 1.125-2.614 2.56C9.386 18.874 10.577 20 12 20s2.614-1.126 2.614-2.56-1.191-2.56-2.614-2.56"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgWifi;
